import { Search, Plus } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { SkillLevelFilter } from '@/components/shared/skill-level-filter';
import { BallLevelFilter } from '@/components/shared/ball-level-filter';

interface PlayerFiltersProps {
  searchInput: string;
  onSearchChange: (value: string) => void;
  levelFilter: string;
  onLevelFilterChange: (value: string) => void;
  ballLevelFilter: string;
  onBallLevelFilterChange: (value: string) => void;
  onAddPlayer: () => void;
}

export function PlayerFilters({
  searchInput,
  onSearchChange,
  levelFilter,
  onLevelFilterChange,
  ballLevelFilter,
  onBallLevelFilterChange,
  onAddPlayer,
}: PlayerFiltersProps) {
  return (
    <div className="flex flex-wrap gap-2">
      <div className="flex-1 min-w-[200px] relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
        <Input
          type="text"
          placeholder="Search players..."
          value={searchInput}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10"
        />
      </div>
      <SkillLevelFilter value={levelFilter} onChange={onLevelFilterChange} />
      <BallLevelFilter value={ballLevelFilter} onChange={onBallLevelFilterChange} />
      <Button onClick={onAddPlayer} className="flex items-center gap-2 shrink-0">
        <Plus className="w-4 h-4" />
        <span className="hidden sm:inline">Add Player</span>
        <span className="sm:hidden">Add</span>
      </Button>
    </div>
  );
}
